import { useEffect, useReducer } from 'react';
import reducer from './reducer';
import getActions from './getActions';
import { IRatingAgenciesState } from '@/creditflowresearch/application/League/interfaces';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';

interface IProps {
  ratingAgenciesInitialState: IRatingAgenciesState,
}

export default ({ ratingAgenciesInitialState }:IProps) => {
  const [state, dispatch] = useReducer(reducer, ratingAgenciesInitialState);
  const { page, perPage } = state;
  const { state: filtersState } = useLeagueTableFiltersContext();
  const selectedPeriod = filtersState.periods.leagueTable.selected;
  const searchText = filtersState.search.value;

  const actions = getActions({ page, perPage, selectedPeriod, searchText }, dispatch);

  useEffect(() => {
    const { data: collection, totalCount } = ratingAgenciesInitialState;

    actions.setRatingAgenciesData({ collection, totalCount });
  }, [ratingAgenciesInitialState]);

  return {
    state,
    ...actions,
  };
};
